import { Signal } from "@lit-labs/signals";
import type {
  IWritableBroadcasterDiagnosticsState,
  QualityRating,
  WarningInfo,
  BroadcasterTelemetrySnapshot,
} from "./types";

export class BroadcasterDiagnosticsState implements IWritableBroadcasterDiagnosticsState {
  readonly qualityScore = new Signal.State<number>(0);
  readonly qualityRating = new Signal.State<QualityRating>("excellent");
  readonly isWarmingUp = new Signal.State<boolean>(true);
  readonly activeWarning = new Signal.State<WarningInfo | null>(null);
  readonly latestSnapshot = new Signal.State<BroadcasterTelemetrySnapshot | null>(null);
  readonly showDebugOverlay = new Signal.State<boolean>(false);
}
